/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { useRecoilValue, useRecoilState } from 'recoil';
import { arrayChangesAtom, changesSendedAtom } from '../Atoms';

const useStyles = makeStyles({
  dial: {
    borderRadius: 'none',
  },
  xIconButton: {
    padding: '0px',
    marginLeft: 0,
  },
  cText: {
    paddingTop: '.5vh',
    paddingLeft: '.5vw',
  },
  confirm: {
    backgroundColor: '#ece7e7',
    color: '#111',
    textAlign: 'center',
    paddingTop: '3vh',
    paddingBottom: '3vh',
    paddingRight: '5vw',
    paddingLeft: '5vw',
  },
  content: {
    paddingTop: '1vh',
    paddingLeft: '1.5vw',
    paddingRight: '1.5vw',
    paddingBottom: 0,
  },
  nav: {
    width: 'inherit',
    backgroundColor: '#00796b',
    padding: '1.5vh',
    color: '#fff',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

function addZero(i) {
  if (i < 10) {
    i = `0${i}`;
  }
  return i;
}
const SaveChangesDialog = function SaveChangesDialog({ open, close }) {
  const classes = useStyles();
  const intl = useIntl();
  const date = new Date();
  const minutes = addZero(date.getMinutes());
  const hour = addZero(date.getHours());
  const [arrayChanges, setArrayChanges] = useRecoilState(arrayChangesAtom);
  const [tmpArrayChanges, setTmpArrayChanges] = useState([]);
  const [changesSended, setChangesSended] = useRecoilState(changesSendedAtom);

  useEffect(() => {
    setTmpArrayChanges([...arrayChanges]);
  }, [arrayChanges]);

  return (
    <Dialog open={open} onClose={close} className={classes.dial}>
      <AppBar className={classes.nav}>
        <IconButton className={classes.xIconButton} onClick={close} color="white">
          <ClearIcon />
        </IconButton>
        <Typography variant="subtitle1" sx={{ mr: '4.5vw' }}>
          {intl.messages.CONFIRMCHANGES}
        </Typography>
      </AppBar>
      <DialogContentText className={classes.cText}>
        <Typography variant="subtitle2">
          {intl.messages.CHANGES}: {tmpArrayChanges?.length}
        </Typography>
      </DialogContentText>
      <DialogContent className={classes.content}>
        <List sx={{ width: 'inherit' }}>
          {tmpArrayChanges?.map((change) => {
            const primaryText = `${change.title} - ${hour}:${minutes}`;
            const secondaryText = `${change.subtitle} - Valore: ${change?.value}`;
            return (
              <div key={change.id}>
                <ListItem sx={{ padding: 0 }}>
                  <ListItemText primary={primaryText} secondary={secondaryText} />
                </ListItem>
                <Divider />
              </div>
            );
          })}
        </List>
      </DialogContent>
      <Divider />
      <Box className={classes.confirm}>
        <Typography variant="subtitle1">{intl.messages.ASK_CONFIRM_CHANGES}</Typography>
      </Box>
      <DialogActions container className={classes.buttons}>
        <Button
          color="error"
          startIcon={<ClearIcon />}
          variant="outlined"
          sx={{ mt: 1, ml: 1, position: 'relative' }}
          onClick={() => {
            close();
            setArrayChanges([]);
          }}
        >
          {intl.messages.DISCARD}
        </Button>
        <Button
          color="primary"
          startIcon={<DoneIcon />}
          variant="outlined"
          sx={{ mt: 1, mr: 1, position: 'relative' }}
          onClick={() => {
            setChangesSended(!changesSended);
            close();
          }}
        >
          {intl.messages.CONFIRMCHANGES}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveChangesDialog;
